import styled from 'styled-components';

export const Column = styled.div<{ justifyContent?: string }>`
    display: flex;
    flex-direction: column;
    justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
`;
